import React, { useEffect, PropsWithChildren, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Box } from '@mui/material';
import adminApi from '../../services/adminApi';
import { analyticsService } from '../../services/analyticsService';

const PublicLayout: React.FC<PropsWithChildren> = ({ children }) => {
    const location = useLocation();
    const [brandingSettings, setBrandingSettings] = useState<any>(null);

    useEffect(() => {
        // Load branding settings for analytics initialization
        const loadBrandingSettings = async () => {
            try {
                const response = await adminApi.getBrandingSettings();
                setBrandingSettings(response.data.data);
                // Initialize analytics if available
                if (response.data.data?.analytics) {
                    analyticsService.initialize(response.data.data.analytics);
                }
            } catch (error) {
                console.error('Failed to load branding settings:', error);
            }
        };

        loadBrandingSettings();

        // Cleanup analytics when component unmounts
        return () => {
            analyticsService.initialize({ enabled: false, type: 'google_analytics' });
        };
    }, []);

    // Track page views
    useEffect(() => {
        if (location) {
            analyticsService.trackPageView(location.pathname);
        }
    }, [location]);

    return (
        <Box sx={{ 
            display: 'flex',
            flexDirection: 'column',
            minHeight: '100vh',
            backgroundColor: brandingSettings?.theme?.backgroundColor || 'transparent'
        }}>
            <Box component="main" sx={{ flexGrow: 1 }}>
                {children || <Outlet />}
            </Box>
        </Box>
    );
};

export default PublicLayout;
